"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../context/store");
const common_1 = require("../../utils/common");
const react_1 = require("react");
const CurrentHourLine = () => {
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { config, colors } = store;
    const [currentTime, setCurrentTime] = (0, react_1.useState)((0, common_1.getCurrentTime)(config.timezone));
    const wrapperStyle = {
        top: currentTime.hour * config.hourHeight +
            (currentTime.minute / 60) * config.hourHeight,
    };
    (0, react_1.useEffect)(() => {
        // 2 minutes interval
        const interval = setInterval(() => {
            setCurrentTime((0, common_1.getCurrentTime)(config.timezone));
        }, 120000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: wrapperStyle, className: 'Kalend__CurrentHourLine' }, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, common_1.parseCssDark)('Kalend__CurrentHourLine__circle', store.isDark), style: {
                    background: store.isDark
                        ? colors.dark.primaryColor
                        : colors.light.primaryColor,
                } }), (0, jsx_runtime_1.jsx)("div", { style: {
                    background: store.isDark
                        ? colors.dark.primaryColor
                        : colors.light.primaryColor,
                }, className: (0, common_1.parseCssDark)('Kalend__CurrentHourLine__line', store.isDark) })] })));
};
exports.default = CurrentHourLine;
